import { apiModeOf, type ApiMode } from '@/api/paths'

/**
 * Public, non-secret build configuration.
 * The browser only needs to know where the gateway lives; company id, credentials and upstream
 * URLs are configured on the gateway server (see apps/gateway/.env.example).
 */
export const env: { apiBase: string; apiMode: ApiMode; appName: string; version: string; isProd: boolean } = {
  /** Base path of the versioned gateway API. Same-origin by default (dev server proxies /api). */
  apiBase: (import.meta.env.VITE_API_BASE as string | undefined)?.replace(/\/+$/, '') || '/api/v1',
  /**
   * `gateway` (default): every call goes through the gateway. `direct`: the screens call the backend itself on the same
   * origin (/admin/v1, the compat /api), signed in with the backend's httpOnly cookie (docs/NO_GATEWAY.md).
   */
  apiMode: apiModeOf(import.meta.env.VITE_API_MODE),
  appName: (import.meta.env.VITE_APP_NAME as string | undefined) || 'COREX',
  version: (import.meta.env.VITE_APP_VERSION as string | undefined) || '0.1.0',
  isProd: import.meta.env.PROD,
}
